import { createSelector } from 'reselect'

const getAvailableModeIds = state => state.searchConfig.availableModeIds
const getIsError = state => state.searchConfig.isError
const getSurfaceData = state => state.searchConfig.surfaceData
const getFlightData = state => state.searchConfig.flightData

const getHasAvailableModes = createSelector(
  [getAvailableModeIds],
  (availableModeIds) => availableModeIds.length > 0
)

export {
  getAvailableModeIds,
  getHasAvailableModes,
  getIsError,
  getSurfaceData,
  getFlightData,
}
